import React from 'react';

export function CanvaIcon() {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clipPath="url(#clip0_1737_5849)">
				<rect width="24" height="24" rx="6" fill="#00C4CC" />
				<rect width="24" height="24" rx="6" fill="#00C4CC" />
				<rect width="24" height="24" rx="6" fill="#00C4CC" />
				<rect width="24" height="24" rx="6" fill="#00C4CC" />
				<rect width="24" height="24" rx="6" fill="#00C4CC" />
				<path
					d="M17.0221 14.2091C16.9332 14.2091 16.855 14.2841 16.7737 14.4479C15.8548 16.3111 14.2679 17.6294 12.4314 17.6294C10.308 17.6294 8.993 15.7125 8.993 13.0644C8.993 8.57869 11.4923 5.98516 13.6875 5.98516C14.7133 5.98516 15.3398 6.62979 15.3398 7.65565C15.3398 8.87317 14.6481 9.51781 14.6481 9.94721C14.6481 10.14 14.768 10.2567 15.0057 10.2567C15.9609 10.2567 17.082 9.15909 17.082 7.60853C17.082 6.10509 15.7735 5 13.5783 5C9.95033 5 6.72607 8.36346 6.72607 13.0172C6.72607 16.6195 8.78313 19 11.9571 19C15.3258 19 17.2737 15.6483 17.2737 14.5604C17.2737 14.3194 17.1506 14.2091 17.0221 14.2091Z"
					fill="white"
				/>
			</g>
			<defs>
				<clipPath id="clip0_1737_5849">
					<path
						d="M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z"
						fill="white"
					/>
				</clipPath>
			</defs>
		</svg>
	);
}
